module.exports = __webpack_public_path__ + "static/calgaryzoo-logo-45bef413d031003105e13b20fe46bdf5.jpg";